import axios from "axios";
import * as actionType from "../../constant/actionType";
export const GetIndividualByEmail = (apidata) => async (dispatch) => {
  /*** API Call Action ***/
  try {
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/GetIndividualByEmail`,
      params: { email: apidata },
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};
